module.exports = __webpack_public_path__ + "static/media/alert-icon.cd227ce7.svg";